(() => {
  if (window.iStoreDeliveryPageLoaded) return;
  window.iStoreDeliveryPageLoaded = true;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const setupRail = (rail) => {
    if (rail.dataset.iStoreDeliveryRailReady === "true") return;

    const viewport = rail.querySelector("[data-istore-delivery-viewport]");
    const track = rail.querySelector("[data-istore-delivery-track]");
    const firstItem = rail.querySelector("[data-istore-delivery-item]");
    const controls = rail.querySelector("[data-istore-delivery-controls]");
    const previousButton = rail.querySelector(
      "[data-istore-delivery-previous]",
    );
    const nextButton = rail.querySelector("[data-istore-delivery-next]");

    if (!viewport || !track || !firstItem) return;

    rail.dataset.iStoreDeliveryRailReady = "true";

    const getStep = () => {
      const gap =
        Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      if (!controls || !previousButton || !nextButton) return;

      const maximumScroll = Math.max(
        0,
        viewport.scrollWidth - viewport.clientWidth,
      );
      const hasOverflow = maximumScroll > 1;

      controls.hidden = !hasOverflow;
      previousButton.disabled = !hasOverflow || viewport.scrollLeft <= 1;
      nextButton.disabled =
        !hasOverflow || viewport.scrollLeft >= maximumScroll - 1;
    };

    const move = (direction) => {
      viewport.scrollBy({
        left: getStep() * direction,
        behavior: reducedMotion.matches ? "auto" : "smooth",
      });
    };

    previousButton?.addEventListener("click", () => move(-1));
    nextButton?.addEventListener("click", () => move(1));

    let animationFrame;
    viewport.addEventListener(
      "scroll",
      () => {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(updateControls);
      },
      { passive: true },
    );

    if ("ResizeObserver" in window) {
      new ResizeObserver(updateControls).observe(viewport);
    } else {
      window.addEventListener("resize", updateControls, { passive: true });
    }

    updateControls();
  };

  const setupRails = (scope = document) => {
    scope.querySelectorAll("[data-istore-delivery-rail]").forEach(setupRail);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupRails(), {
      once: true,
    });
  } else {
    setupRails();
  }

  document.addEventListener("shopify:section:load", (event) =>
    setupRails(event.target),
  );
})();
